var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[_vm.prefixCls + '-item-group']},[_c('div',{class:[_vm.prefixCls + '-item-group-title'],style:(_vm.groupStyle)},[_vm._v(_vm._s(_vm.title))]),_c('ul',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }